module.exports = require('./helpers/bundle-url').getBundleURL('ksUvU') + "popup_banner2.822d18a2.png" + "?" + Date.now();